// removed by extract-text-webpack-plugin
module.exports = {"large":"1600px","desktop":"1366px","ipad":"1024px","ipad-portrait":"768px","mobile":"480px","white":"#ffffff","section":"_1BRuK6BkBNA4f6-oexN4NT","filterable":"_24K9aldWUn-zFuCvYEq_HH","highCard":"_1ZvcUsWGDnsLFaQKeVS1XE","lowCard":"_1jyJL_GfImTIVKQdHW3cvi","grid":"_2BjeSChKKgIaINN7jcfe29","gridItem":"_2DffXCG5PGX4OJKayqakXw","gridSizer":"_2wiyoKXmSqdZ1mU2Yye3-U"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/components/Banner/OthersBanner/ArticlesBanner/TypeB/TypeB.css
// module id = 1425
// module chunks = 0